import { render, staticRenderFns } from "./PzYousignForm.vue?vue&type=template&id=a9686500"
import script from "./PzYousignForm.vue?vue&type=script&lang=js"
export * from "./PzYousignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9686500')) {
      api.createRecord('a9686500', component.options)
    } else {
      api.reload('a9686500', component.options)
    }
    module.hot.accept("./PzYousignForm.vue?vue&type=template&id=a9686500", function () {
      api.rerender('a9686500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Yousign/PzYousignForm.vue"
export default component.exports